<template>
    <b-modal
            size="md"
            :visible="show"
            @hidden="hideEvents"
            :id="modalId"
            :title="title"
            class="note-modal"
            :scrollable=false
    >
        <vue-element-loading :active="loading"></vue-element-loading>
        <r-form
                class="file-form"
                v-if="form"
                :column-size="1"
                :crud="true"
                :validators="validators"
                :showHeader="false"
                :showFooter="false"
                ref="form"
                v-model="form"
                :disabled="false"
        >
        </r-form>
        <b-form>
            <vue-dropzone
                    v-if="fileUrl"
                    id="fileDrop"
                    ref="dropzone"
                    :options="dropOptions"
                    @vdropzone-sending="attachParams"
                    @vdropzone-success-multiple="onFileMultipleSuccess"
                    @vdropzone-success="onFileSuccess"
                    @vdropzone-error="onFileError"
                    @vdropzone-file-added="checkForDuplicates"
            >
            </vue-dropzone>
        </b-form>
        <template slot="modal-footer">
            <b-button
                    variant="outline-secondary"
                    class="cancel"
                    @click="hideModal">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                    variant="yellow"
                    @click="onUploadFiles"
            >
                {{ buttonText }}
                <font-awesome-icon
                        class="ml-3"
                        :icon="['fal', 'upload']"
                >
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin';
import FileDropMixin from '@/components/Form/FileDropMixin';
import RForm from '@/components/Form/RiskhubForm';
import { forEach } from 'lodash';

export default {
  name: 'File-Modal',
  components: {
    RForm,
  },
  props: {
    show: {
      default: false,
    },
    title: {
      default: 'Upload file',
    },
    busy: {
      default: false,
    },
    buttonText: {
      default: 'Upload',
    },
    errorMessage: {
      type: String,
    },
    form: {
      type: Object,
      required: false,
    },
    validators: {
      type: Object,
      required: false,
    },
    options: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  mixins: [FileDropMixin, ModalMixin],
  data() {
    return {
      modalId: 'fileModal',
      dropOptions: {
        ...this.options,
        dictDefaultMessage: 'Drop file here to upload, or click to <span class="underline">select</span> a file to upload.',
      },
      filesProcessed: [],
      fileCount: 0,
    };
  },
  watch: {
    busy: {
      handler(newBusy) {
        this.loading = newBusy;
      },
      immediate: true,
    },
  },
  methods: {
    async onUploadFiles() {
      this.loading = true;

      // File route, post via dropzone
      if (!this.fileUrl || !this.getFiles().length) {
        this.$notify({
          title: 'No files selected',
          text: 'Please upload at least one file.',
          type: 'warn',
        });

        this.loading = false;

        return;
      }

      const form = await this.form;

      // Because the it is not mandatory to have a file type, we default
      // isValidated to true
      const isValidated = true;

      this.fileCount = this.getFiles().length;

      if (isValidated) {
        this.processFiles();
      }
    },

    hideModalEvents() {
      this.$emit('update:show');
    },

    onFileMultipleSuccess(file, response) {
      this.$emit('file-sent', response);
      this.$emit('all-files-sent', response);
      this.loading = false;
      this.hideModal();
    },

    onFileSuccess(file, response) {
      this.$emit('file-sent', response);
      this.loading = false;

      this.filesProcessed.push(file);

      if (this.filesProcessed.length === this.fileCount) {
        this.hideModal();
        this.$emit('all-files-sent', response);
      }
    },

    attachParams(file, xhr, formData) {
      forEach(this.form, (object, key) => {
        formData.append(key, this.form[key].value);
      });
    },

    resetForm() {
      forEach(this.form, (object, key) => {
        this.form[key].value = '';
      });
    },

    showErrorRequired() {
      const title = 'File or note is required';
      const text = '';
      const type = 'error';

      this.$notify({
        duration: 7000,
        title,
        text,
        type,
      });
    },
  },
};
</script>

<style lang="scss" >
    .file-form {
        z-index: 30;

        .form-body {
            padding: 0;
        }
    }
</style>
